<template>
  <div class="row">
    <div class="col-12">
      <card>
        
        <div class="form-group">
          <div :class="{'input-group': true, 'input-group-lg': true, 'input-group-focus': searchBoxFocused}">
            <div class="input-group-prepend">
              <span class="input-group-text br-1">
                <i class="tim-icons icon-zoom-split"></i>
              </span>
            </div>
            <input v-on:keyup.enter="changePage(1);" type="text" 
                    @focus="searchBoxFocused=true"
                    @blur="searchBoxFocused=false"
                    style="border-radius:0;" 
                    class="form-control" 
                    placeholder="search tax id number, company title or trade title"
                    v-model="searchQuery">
            <div class="input-group-append" style="border:0px;">
              <button @click="changePage(1);" class="btn btn-primary m-0" type="button">Search</button>
            </div>
          </div>         
        </div>

        <div class="table-responsive" style="overflow: auto;">
          <table class="table companies-table">
            <thead>
            <tr>
              <th style="width: 20%;">Tax&nbsp;ID&nbsp;Number</th>
              <th style="width: 20%">Trade&nbsp;Title</th>
              <th style="width: 50%;">Title</th>
              <th style="width: 10%;"></th>
            </tr>
            </thead>
            <tbody v-if="loading === false && companies.length>0">
              <tr v-for="(item, index) in companies" :key="index">
                <td style="width: 20%;">{{ item.vatNumber }}</td>
                <td style="width: 20%">{{ item.tradeTitle }}</td>
                <td style="width: 50%;">{{ item.title }}</td>
                <td style="width: 10%;"><router-link :to="{path:'/companies/' + item.id}">view</router-link></td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-if="loading === false">
                <td colspan="4">No companies found</td>
              </tr>
              <tr v-else>
                <td colspan="4">Loading, plase wait...</td>
              </tr>
            </tbody>
          </table>
        </div>

        <pagination @pageChanged="changePage" :current-page="pagination.currentPage" :per-page="pagination.perPage" :total-rows="pagination.totalRows" :total-pages="pagination.totalPages"></pagination>
      </card>
    </div>
  </div>
</template>
<script>
  import Api from '../api';
  import Pagination from "../components/Pagination";
  export default {
    components: {
      Pagination
    },
    data() {
      return {
        searchBoxFocused: false,
        loading: true,
        companies: [],
        searchQuery: '',
        pagination: {
          currentPage: 1,
          perPage: 10,
          totalRows: 0,
          totalPages: 0
        }
      }
    },
    mounted() {
      this.fetchCompanies();
    },
    methods: {
      fetchCompanies() {
        let self = this;
        Api.send('GET', '/prism/companies?page=' + self.pagination.currentPage + '&per_page=' + self.pagination.perPage + '&query=' + encodeURI(self.searchQuery), {})
        .then((response) => {
          self.companies = response.data;
          self.pagination = response.pagination;
        })
        .catch((err) => {
          self.errorMessage = err.msg;
          self.companies = [];
        })
        .finally(() => {
          self.loading = false;
        });
      },
      changePage(page) {
        this.pagination.currentPage = page;
        this.fetchCompanies();
      }
    }
  }
</script>
<style>
.companies-table th {
  white-space: nowrap;
}
.input-group-prepend.focused {
  border-color: red;
}
</style>
